module.exports = "/assets/1f5ce8d6fd3bd3d44da984e3bc191efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/IR.png
// module id = 2609
// module chunks = 0